import { Icon } from '@/components/Icon';
import { ProblemAlert } from '@/components/ProblemAlert';
import { Button } from '@/components/ui/button';
import { SheetFooter } from '@/components/ui/sheet';
import type { RunBuildFormModel } from './useRunBuildForm';

/** Problem alert plus Preview / Cancel / Run. Run is disabled by a launch block or a blocked plan, and says why on hover. */
export function RunBuildFooter({ form }: { form: RunBuildFormModel }) {
  const { target, preview, launchBlock, blocked, count, isPending } = form;
  return (
    <SheetFooter className="border-t">
      <ProblemAlert error={form.problem} testId="run-build-problem" />
      <div className="flex flex-wrap items-center gap-2">
        <Button type="button" variant="outline" data-testid="run-build-preview" loading={isPending && preview === null} disabled={target.loadingBasics} onClick={() => void form.onPreview()}>
          <Icon name="visibility" size={18} />
          Preview
        </Button>
        <span className="ml-auto flex gap-2">
          <Button type="button" variant="ghost" data-testid="run-build-cancel" onClick={form.closeRunBuild}>
            Cancel
          </Button>
          <Button type="submit" data-testid="run-build-submit" data-blocked-reason={launchBlock} loading={isPending && preview !== null} disabled={target.loadingBasics || blocked} title={launchBlock ?? (blocked ? 'The plan has a blocking check' : undefined)}>
            <Icon name="bolt" size={18} />
            Run {count > 1 ? `${count} builds` : 'build'}
          </Button>
        </span>
      </div>
    </SheetFooter>
  );
}
